// export const LOGOUT = 'LOGOUT'
export const SET_ERROR = 'SET_ERROR'

export const EX_REQUEST = 'EX_REQUEST'
export const EX_SUCCESS = 'EX_SUCCESS'
export const EX_FAILURE = 'EX_FAILURE'

export const VERIFY_REQUEST = 'VERIFY_REQUEST'
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS'
export const VERIFY_FAILURE = 'VERIFY_FAILURE'

export const CORE_LOAD_ROOMINFO_REQUEST = 'CORE_LOAD_ROOMINFO_REQUEST'
export const CORE_LOAD_ROOMINFO_SUCCESS = 'CORE_LOAD_ROOMINFO_SUCCESS'
export const CORE_LOAD_ROOMINFO_FAILURE = 'CORE_LOAD_ROOMINFO_FAILURE'


// WEBPACK FOOTER //
// ./src/types.js